// The PDF renderer is large, so it is only fetched when a PDF is actually shown.
export default function loadPdfEmbed() {
  return import(
    /* webpackChunkName: "pdf-embed" */ 'vue-pdf-embed/dist/vue2-pdf-embed'
  ).then((module) => module.default || module)
}
